import { TableBody, TableCell, TableRow } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

interface Props {
  colSpan: number;
  rows: number;
}

export default function Loader({ colSpan, rows }: Props) {
  return (
    <TableBody>
      {[...Array(rows).keys()].map(id => (
        <TableRow key={`loading_${id}`}>
          <TableCell align="center" colSpan={colSpan}>
            <Skeleton variant="rect" height={20} />
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
}
